var SelectController = /** @class */ (function () {
    function SelectController() {
        this._selected = new Set();
    }
    SelectController.prototype.toggleSelectItem = function (item, selected) {
        if (typeof selected !== 'boolean') {
            if (this._selected.has(item)) {
                this._selected.delete(item);
                return false;
            }
            this._selected.add(item);
            return true;
        }
        if (selected) {
            this._selected.add(item);
        }
        else {
            this._selected.delete(item);
        }
        return selected;
    };
    SelectController.prototype.eachItem = function (callback) {
        this._selected.forEach(callback);
    };
    SelectController.prototype.isSelected = function (item) {
        return this._selected.has(item);
    };
    SelectController.prototype.select = function (item, mode) {
        if (mode === void 0) { mode = 'single'; }
        if (mode === 'single') {
            this.unselectAll();
        }
        this._selected.add(item);
    };
    SelectController.prototype.unselect = function (item) {
        this._selected.delete(item);
    };
    SelectController.prototype.unselectAll = function () {
        this._selected.clear();
    };
    return SelectController;
}());
export { SelectController };
